<template>
  <div class="w3-container w3-content" style="width: 100%; padding-top: 60px; margin: auto">    
    <!-- The Grid -->
    <div class="w3-row">
      <div class="w3-col">
        <div class="w3-card w3-round w3-white">
          <div class="w3-container w3-padding">
            <h6 v-if="!isAuthenticated" style="text-align:center">
              <login-button v-bind:text="'Login to submit feedback'" />
            </h6>
            <div v-else>
              <h6 class="w3-opacity" style="text-align:center">Submit Feedback</h6>
              <h6 v-if="isFeedbackSuccess" style="text-align:center">Feedback submitted, thank you!</h6>
              <div class="w3-left-align">
                <input ref="title" v-focus="inputFocused" @focus="inputFocused = true" @blur="inputFocused = false" type="text" name="title" placeholder="TITLE" v-model="feedbackForm.title" class="form-control">
                <textarea-autosize ref="body" rows="3" placeholder="Share your feedback..." v-model="feedbackForm.body" class="form-control"></textarea-autosize>
              </div>
              <div>
                <save-button @save="addFeedback()" v-bind:type="'fal'" v-bind:icon="'comments'"/>
                &nbsp;
                <clear-button @clear="resetForm()"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  <!-- End Page Container -->
  </div>
</template>

<script>
  import FeedbackAdd from './FeedbackAdd.ts'
  export default FeedbackAdd
</script>
